<template>
  <v-layout wrap>
    <!--
		<div class="background"></div>
    -->
    <v-flex v-if="!hideExtra" sm12 class="white--text">
      <p>{{ participant.name }}</p>
    </v-flex>
    <v-flex v-if="!hideExtra" sm12 class="white--text">
      <p>{{ participant.work }}</p>
    </v-flex>
    <v-flex sm12>
      <v-card class="pa-6">
        <div id="content"></div>
        <v-divider v-if="hideExtra"></v-divider>

        <v-card-actions v-if="hideExtra">
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="$emit('closeDialog')">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-flex>

    <v-flex v-if="!hideExtra" xs12 class="d-flex flex-row-reverse">
      <v-btn @click="send" rounded class="white" style="padding: 0 1rem">Continuar</v-btn>
    </v-flex>

    <v-snackbar v-model="snackbar" right top :timeout="3000">
      {{ message }}
      <v-btn color="blue" text @click="snackbar = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-snackbar>
  </v-layout>
</template>

<script>
import EditorJS from "@editorjs/editorjs";
import Header from "@editorjs/header";
import List from "@editorjs/list";
import axios from "axios";
export default {
  props: { hideExtra: Boolean },
  data() {
    return {
      editor: null,
      snackbar: false,
      message: "",
      participant: JSON.parse(sessionStorage.getItem("participant")),
      host: process.env.VUE_APP_HOST
    };
  },
  methods: {
    send() {
      this.$router.push({ name: "personaldata" });
    },
    init() {
      let data = {
        type: "help_participant"
      };

      axios
        .post(this.host + "/settings/read.php", this.createFormData(data))
        .then(response => {
          var html = "";

          let json = JSON.parse(response.data.data.content);

          json.blocks.forEach(function(block) {
            switch (block.type) {
              case "header":
                html += `<h${block.data.level}>${block.data.text}</h${block.data.level}>`;
                break;
              case "paragraph":
                html += `<p>${block.data.text}</p>`;
                break;
              case "delimiter":
                html += "<hr />";
                break;
              case "image":
                html += `<img class="img-fluid" src="${block.data.file.url}" title="${block.data.caption}" /><br /><em>${block.data.caption}</em>`;
                break;
              case "list":
                html += "<ul>";
                block.data.items.forEach(function(li) {
                  html += `<li>${li}</li>`;
                });
                html += "</ul>";
                break;
              default:
                console.log("Unknown block type", block.type);
                console.log(block);
                break;
            }
            document.getElementById("content").innerHTML = html;
          });
        })
        .catch(error => {
          console.log(error);
        });
    },
    createFormData(postData) {
      let formDa = new FormData();
      for (let key in postData) {
        formDa.append(key, postData[key]);
      }
      return formDa;
    }
  },
  mounted() {
    this.init();
  }
};
</script>

<style scoped>
.background {
  position: relative;
  background-color: rgba(0, 0, 0, 0.5);
  height: 95%;
  width: 100%;
  z-index: 100;
}
.front {
  position: relative;
  z-index: 10;
}
</style>